var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('AppHeader',{attrs:{"navItems":_vm.navItems}}),_c('router-view'),_c('AppFooter',{attrs:{"navShortcuts":_vm.navShortcuts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }